import { Icon } from '@rsuite/icons';
import React, { useEffect, useState } from 'react';
import { MdGroups } from 'react-icons/md';
import { Col, Panel, Row } from 'rsuite';
import * as images from '../../images/charts';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { getTotalUsers } from '@/services/dashboard.service';
import AdminWaitingJobDataTable from './AdminWaitingJobDataTable';
import RegisteredUsersBarChart from './RegisteredUsersBarChart';

const Dashboard = () => {
  const [totalUsers, setTotalUsers] = useState<number|undefined>(undefined);
  
  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    fetchTotalUsers();
  }


  async function fetchTotalUsers(){
      try {
        const result: BaseResponseModel<number> = await getTotalUsers();
        if (result.success) {
          setTotalUsers(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching total users: ${errorModel?.errorMessage}`);
      }
      finally {
      }
  }
  return (
    <>
      <Row gutter={30} className="dashboard-header">
        <Col span={{xs:8}}>
          <Panel className="trend-box bg-gradient-blue">
            <Icon className="chart-img" as={MdGroups} style={{fontSize:'5em'}}/>
            <div className="title">Total Users</div>
            <div className="value">{totalUsers?.toLocaleString()}</div>
          </Panel>
        </Col>
        <Col span={{xs:8}}>
          <Panel className="trend-box bg-gradient-green">
            <img className="chart-img" src={images.VVICon} />
            <div className="title"> --- </div>
            <div className="value"> --- </div>
          </Panel>
        </Col>
        <Col span={{xs:8}}>
          <Panel className="trend-box bg-gradient-red">
            <img className="chart-img" src={images.PVIcon} />
            <div className="title"> --- </div>
            <div className="value"> --- </div>
          </Panel>
        </Col>
      </Row>
      
      <Row gutter={30}>
        <Col span={{xs:16}}>
          <RegisteredUsersBarChart />
        </Col>
        <Col span={{xs:8}}>
          <AdminWaitingJobDataTable />
        </Col>
      </Row>      
    </>
  );
};

export default Dashboard;


